import { IColor, IGetColorsResponse, IUpdateColorRequest, TColorTypes } from 'types';
import { cdmApi } from '.';

const PREFIX = '/colors';

const colorsApi = cdmApi.injectEndpoints({
    endpoints: (builder) => ({
        getColors: builder.query<IGetColorsResponse, { unset: boolean; type: TColorTypes }>({
            query: (params) => ({ url: `${PREFIX}/`, method: 'get', params }),
            providesTags: () => [{ type: 'Colors', id: 'LIST' }],
        }),

        addColor: builder.mutation<any, IColor>({
            query: (data) => ({ url: `${PREFIX}/`, method: 'post', data }),
            invalidatesTags: [{ type: 'Colors', id: 'LIST' }],
        }),

        updateColor: builder.mutation<any, IUpdateColorRequest>({
            query: (data) => ({ url: `${PREFIX}/`, method: 'put', data }),
            invalidatesTags: [{ type: 'Colors', id: 'LIST' }],
        }),

        deleteColor: builder.mutation<any, { color_id: number }>({
            query: (data) => ({
                url: `${PREFIX}/${data.color_id}
            `,
                method: 'delete',
            }),
            invalidatesTags: [{ type: 'Colors', id: 'LIST' }],
        }),
    }),

    overrideExisting: false,
});

export const { useGetColorsQuery, useAddColorMutation, useUpdateColorMutation, useDeleteColorMutation } = colorsApi;
